import React from 'react'
import { Chip, ChipProps } from '@mui/material'
import useThemeMode from '../../hooks/useThemeMode'

interface StatusChipProps {
  label: string
  color: string
  bg: string
  darkColor: string
  darkBg: string
  size?: ChipProps['size']
}

const StatusChip = ({ label, color, bg, darkColor, darkBg, size = 'small' }: StatusChipProps) => {
  const { isDark } = useThemeMode()

  return (
    <Chip
      size={size}
      label={label}
      sx={{
        fontWeight: 600,
        fontSize: '12px',
        borderRadius: '6px',
        color: isDark ? darkColor : color,
        bgcolor: isDark ? darkBg : bg,
      }}
    />
  )
}

export default StatusChip
